import Cookies from 'js-cookie';

const TokenKey = 'localTicket';

export function getToken() {
  return Cookies.get(TokenKey) || JSON.parse(window.localStorage.getItem(TokenKey) || '""');
}

export function setToken(token) {
  window.localStorage.setItem(TokenKey, JSON.stringify(token || ''));
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  window.localStorage.removeItem(TokenKey);
  return Cookies.remove(TokenKey);
}
